function setupMobileScroll() {
    const row = document.querySelector(".container-1470 .halo-row.column-4");
    if (!row) return;
    if ((row.dataset.originalHtml || (row.dataset.originalHtml = row.innerHTML), !(window.innerWidth < 750))) {
        (row.innerHTML = row.dataset.originalHtml),
            (row.style.display = ""),
            (row.style.overflowX = ""),
            (row.style.flexWrap = "");
        return;
    }
    if (row.querySelector(".halo-scroll-page")) return;
    const tempContainer = document.createElement("div");
    tempContainer.innerHTML = row.dataset.originalHtml;
    const items = Array.from(tempContainer.querySelectorAll(".halo-item"));
    (row.innerHTML = ""), (row.style.display = "flex"), (row.style.overflowX = "auto"), (row.style.flexWrap = "nowrap");
    for (let i = 0; i < items.length; i += 4) {
        const group = document.createElement("div");
        group.classList.add("halo-scroll-page"),
            items.slice(i, i + 4).forEach((item) => group.appendChild(item)),
            row.appendChild(group);
    }
}

window.addEventListener("DOMContentLoaded", setupMobileScroll);
window.addEventListener("resize", () => {
    clearTimeout(window._haloResizeTimeout);
    window._haloResizeTimeout = setTimeout(setupMobileScroll, 200);
});

document.addEventListener("DOMContentLoaded", function () {
    const slider = document.getElementById("tagFilter");
    
    // Null check to prevent error when tagFilter doesn't exist
    if (!slider) return;
    
    let isDown = false;
    let startX, scrollLeft;
    
    slider.addEventListener("mousedown", (e) => {
        isDown = true;
        slider.classList.add("active");
        startX = e.pageX - slider.offsetLeft;
        scrollLeft = slider.scrollLeft;
    });
    
    slider.addEventListener("mouseleave", () => {
        isDown = false;
        slider.classList.remove("active");
    });
    
    slider.addEventListener("mouseup", () => {
        isDown = false;
        slider.classList.remove("active");
    });
    
    slider.addEventListener("mousemove", (e) => {
        if (!isDown) return;
        e.preventDefault();
        const walk = (e.pageX - slider.offsetLeft - startX) * 2;
        slider.scrollLeft = scrollLeft - walk;
    });
    
    slider.addEventListener("touchstart", (e) => {
        startX = e.touches[0].pageX;
        scrollLeft = slider.scrollLeft;
    });
    
    slider.addEventListener("touchmove", (e) => {
        const walk = (e.touches[0].pageX - startX) * 2;
        slider.scrollLeft = scrollLeft - walk;
    });
});